// Test IDs for the Shabbat Shalom, America site.
export const SITE = {
        navLogo: 'site-nav-logo',
        navStory: 'site-nav-story',
        navListen: 'site-nav-listen',
        navJoin: 'site-nav-join',
        navSourceNotes: 'site-nav-source-notes',
        heroTitle: 'hero-title',
        heroPreviewBtn: 'hero-preview-btn',
        heroJoinBtn: 'hero-join-btn',
        audioPlayer: 'audio-player',
        audioPlayBtn: 'audio-play-btn',
        demoNotice: 'demo-notice',
        storySection: 'story-section',
        whyNowSection: 'why-now-section',
        versionsSection: 'versions-section',
        gratitudeSection: 'gratitude-section',
        signupForm: 'signup-form',
        signupName: 'signup-name',
        signupEmail: 'signup-email',
        signupOrg: 'signup-organization',
        signupMessage: 'signup-message',
        signupSubmit: 'signup-submit',
        signupSuccess: 'signup-success',
        footer: 'site-footer',
        footerSourceNotesLink: 'footer-source-notes-link',
        sourceNotesPage: 'source-notes-page',
        sourceNotesBack: 'source-notes-back',
};
